import React from 'react';

type Props = {
    expand: boolean,
    handleExpand: () => void,
    hasNoNode: boolean
}

const RightArrowIcon: React.FC<Props> = ({ expand, handleExpand, hasNoNode }) => {
    return (
        <svg onClick={() => handleExpand()} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${hasNoNode ? 'invisible':''} w-6 h-5  cursor-pointer transform transition-transform duration-300 ${expand === false ? "rotate-360" : "rotate-90"}`}>
            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
    )
}

export default RightArrowIcon;